import '../dashboard.css';
import '../../card/card.css';
import '../../submission/submission.css';
import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CoverDisplay from '../../components/ImagesPageGradeLink';
import BannerImage from '../../assets/Space.jpg';
import PsaWhiteLogo from '../../../assets/logos/PSA-White.png';

const TARGET_TAG_NAME = 'PSA Vault';

const toGradeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

function DashboardPsaVaultTag() {
  const [tag, setTag] = useState(null);
  const [cardList, setCardList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [submissionTotals, setSubmissionTotals] = useState({
    sub_precost: 0,
    sub_shipping_to: 0,
    sub_shipping_from: 0,
    sub_upcharge: 0,
    sub_total_cost: 0,
  });

  useEffect(() => {
    let mounted = true;

    const loadPsaVaultCards = async () => {
      try {
        setLoading(true);
        setErrorMessage('');

        const tagResponse = await Axios.get('https://api.alientrader.cards/tags');
        const matchingTag = (tagResponse.data || []).find(
          (item) => String(item.tag_name || '').toLowerCase() === TARGET_TAG_NAME.toLowerCase()
        );

        if (!matchingTag) {
          if (mounted) {
            setTag(null);
            setCardList([]);
            setErrorMessage(`The "${TARGET_TAG_NAME}" tag does not exist yet.`);
          }
          return;
        }

        const cardsResponse = await Axios.get(`https://api.alientrader.cards/tags/${matchingTag.tag_id}/cards`);

        if (mounted) {
          setTag(cardsResponse.data?.tag || matchingTag);
          setCardList(cardsResponse.data?.cards || []);
        }
      } catch (error) {
        console.error('Error fetching PSA Vault tag wall:', error);
        if (mounted) {
          setTag(null);
          setCardList([]);
          setErrorMessage('Unable to load PSA Vault cards right now.');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadPsaVaultCards();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const loadSubmissionTotals = async () => {
      const submissionIds = [...new Set(
        cardList
          .map((card) => card.card_grade_sub)
          .filter((value) => value !== null && value !== undefined && String(value).trim() !== '')
      )];

      if (submissionIds.length === 0) {
        if (mounted) {
          setSubmissionTotals({
            sub_precost: 0,
            sub_shipping_to: 0,
            sub_shipping_from: 0,
            sub_upcharge: 0,
            sub_total_cost: 0,
          });
        }
        return;
      }

      try {
        const responses = await Promise.all(
          submissionIds.map((submissionId) =>
            Axios.get(`https://api.alientrader.cards/submission/${submissionId}`)
          )
        );

        const totals = responses.reduce((acc, response) => {
          const submission = response.data?.[0] || {};
          acc.sub_precost += Number(submission.sub_precost || 0);
          acc.sub_shipping_to += Number(submission.sub_shipping_to || 0);
          acc.sub_shipping_from += Number(submission.sub_shipping_from || 0);
          acc.sub_upcharge += Number(submission.sub_upcharge || 0);
          acc.sub_total_cost += Number(submission.sub_total_cost || 0);
          return acc;
        }, {
          sub_precost: 0,
          sub_shipping_to: 0,
          sub_shipping_from: 0,
          sub_upcharge: 0,
          sub_total_cost: 0,
        });

        if (mounted) {
          setSubmissionTotals(totals);
        }
      } catch (error) {
        console.error('Error fetching PSA Vault submission totals:', error);
        if (mounted) {
          setSubmissionTotals({
            sub_precost: 0,
            sub_shipping_to: 0,
            sub_shipping_from: 0,
            sub_upcharge: 0,
            sub_total_cost: 0,
          });
        }
      }
    };

    loadSubmissionTotals();

    return () => {
      mounted = false;
    };
  }, [cardList]);

  const gradeCount10 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 10).length;
  const gradeCount95 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 9.5).length;
  const gradeCount9 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 9).length;
  const gradeCount85 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 8.5).length;
  const gradeCount8 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 8).length;
  const gradeCount75 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 7.5).length;
  const gradeCount7 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 7).length;
  const gradeCountBelow7 = cardList.filter((card) => {
    const gradeNumber = toGradeNumber(card.card_grade_number);
    return gradeNumber !== null && gradeNumber < 7;
  }).length;
  const totalCardCosts = cardList.reduce((sum, card) => sum + Number(card.card_total_cost || 0), 0);
  const formatCurrency = (value) => `$${Number(value || 0).toFixed(2)}`;

  return (
    <div className="imagesPage">
      <div
        className="subTopBG"
        style={{
          backgroundImage: `url(${BannerImage})`,
          backgroundPosition: 'center -40px',
        }}
      >
        <div className="actions" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="subBack"></div>
          <div className="sub" style={{ color: '#f4f7fb' }}></div>
          <div className="subEdit" style={{ width: 'auto', marginRight: '0' }}></div>
        </div>
        <div className="subHeader">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
            <img
              src={PsaWhiteLogo}
              alt="PSA"
              style={{
                opacity: 0.75,
                maxWidth: '180px',
                width: '100%',
                height: 'auto',
              }}
            />
            <div style={{ opacity: 0.9, marginTop: '-20px' }}>Vault</div>
          </div>
        </div>
      </div>

      <div className="subPositionAdjust" style={{ top: '-130px' }}>
        <Container fluid style={{ paddingLeft: '30px', paddingRight: '30px' }}>
          <Row className="d-flex align-items-center justify-content-center" style={{ marginBottom: '10px' }}>
            <Col xs="9" sm="5" lg="5" xl="3" className="custom-info-box shadow-sm">
              <Row><div className="custom-info-header">Information</div></Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Total Card Vaults:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : cardList.length}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Cost:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : formatCurrency(submissionTotals.sub_precost)}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Shipping to:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : formatCurrency(submissionTotals.sub_shipping_to)}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Shipping from:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : formatCurrency(submissionTotals.sub_shipping_from)}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Upcharge Cost:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : formatCurrency(submissionTotals.sub_upcharge)}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Total Grading Cost:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : formatCurrency(submissionTotals.sub_total_cost)}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Total Card Costs:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : formatCurrency(totalCardCosts)}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Link to Vault:</div></Col>
                <Col xs={5} sm={5}>
                  <div className="custom-info-val">
                    <a
                      href="https://app.collectors.com/collection/vaulted"
                      target="_blank"
                      rel="noreferrer"
                    >
                      PSA
                    </a>
                  </div>
                </Col>
              </Row>
              <Row><br /></Row>
            </Col>
          </Row>

          <Row className="d-flex align-items-center justify-content-center" style={{ marginBottom: '10px' }}>
            <Col xs="9" sm="5" lg="3" xl="2" className="custom-info-box shadow-sm">
              <Row><div className="custom-info-header">Grades</div></Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">GEM MINT - 10:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount10}</div></Col>
                <Col xs={4} sm={4}><div className="custom-info-val"></div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">MT - 9:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount9}</div></Col>
                {(!loading && !errorMessage && gradeCount95 > 0) ? (
                  <>
                    <Col xs={1} sm={1}><div className="custom-info-title">9.5+</div></Col>
                    <Col xs={3} sm={3}><div className="custom-info-val">{gradeCount95}</div></Col>
                  </>
                ) : (
                  <>
                    <Col xs={1} sm={1}></Col>
                    <Col xs={3} sm={3}></Col>
                  </>
                )}
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">NM-MT - 8:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount8}</div></Col>
                {(!loading && !errorMessage && gradeCount85 > 0) ? (
                  <>
                    <Col xs={1} sm={1}><div className="custom-info-title">8.5+</div></Col>
                    <Col xs={3} sm={3}><div className="custom-info-val">{gradeCount85}</div></Col>
                  </>
                ) : (
                  <>
                    <Col xs={1} sm={1}></Col>
                    <Col xs={3} sm={3}></Col>
                  </>
                )}
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">NM - 7:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount7}</div></Col>
                {(!loading && !errorMessage && gradeCount75 > 0) ? (
                  <>
                    <Col xs={1} sm={1}><div className="custom-info-title">7.5+</div></Col>
                    <Col xs={3} sm={3}><div className="custom-info-val">{gradeCount75}</div></Col>
                  </>
                ) : (
                  <>
                    <Col xs={1} sm={1}></Col>
                    <Col xs={3} sm={3}></Col>
                  </>
                )}
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Below 7:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCountBelow7}</div></Col>
                <Col xs={4} sm={4}><div className="custom-info-val"></div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
          </Row>

          <Row className="d-flex align-items-center justify-content-center">
            <Col xxl={10} xl={11} lg={12} md={12} className="custom-info-box shadow-sm">
              <Row>
                <div className="custom-info-header">Card Wall</div>
              </Row>
              <Row className="subCardWall d-flex align-items-center justify-content-center">
                {loading ? (
                  <Col>
                    <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                      Loading PSA Vault cards...
                    </div>
                  </Col>
                ) : errorMessage ? (
                  <Col>
                    <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                      {errorMessage}
                    </div>
                  </Col>
                ) : cardList.length > 0 ? (
                  cardList.map((item, index) => (
                    <Col className="imagesPageRow d-flex align-items-center justify-content-center" key={item.card_id}>
                      <CoverDisplay key={index} image={item} />
                    </Col>
                  ))
                ) : (
                  <Col>
                    <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                      No cards are currently tagged with "{TARGET_TAG_NAME}".
                    </div>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default DashboardPsaVaultTag;
